import styled from 'styled-components';

interface VideoItemProps {
    $isReflected?: boolean;
}

export const VideoItem = styled.video<VideoItemProps>`
    object-position: center;
    border-radius: 8px;
    min-height: 0;
    min-width: 0;

    width: 100%;
    height: 100%;
    object-fit: contain;

    --video-base-transform: ${({ $isReflected }) => ($isReflected ? 'scaleX(-1)' : 'scaleX(1)')};
    transform: var(--video-base-transform);
`;
